export default __webpack_public_path__ + "static/media/-logos_blue.4e1d9d33.png";